import { useQuery } from "@tanstack/react-query";
import {downloadRedemptionReport} from "../../service/query/auth";

export const useDownloadRedemptionReport = ({
  payload,
}) => {
  const redemptionReport = useQuery({
    queryKey: ["redemptionReport", payload],
    queryFn: () => downloadRedemptionReport({ ...payload }),
    enabled: !!payload,
    keepPreviousData: true,
  });

  return { data: redemptionReport?.data?.data, ...redemptionReport };
};
